export class ourPartners {
    image:string= ''
    title:string= ''
    titleAr:string= ''
    companyTypeId:number=null



}
export class UpdateourPartners {
    id:number=null
    image:string= ''
    title:string= ''
    companyTypeId:number=null




}